/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { PointDtoModel } from '@well/address-management-domain-model';

export class DelAddressListVO extends JSONable {

  uuid: string | undefined = undefined;
  isOwnedByProfile: boolean | undefined = undefined;
  ownerCompanyName: string | undefined = undefined;
  companyName: string | undefined = undefined;
  businessProfileUuid: string | undefined = undefined;
  addressLine: string | undefined = undefined;
  city: string | undefined = undefined;
  state: string | undefined = undefined;
  postalCode: string | undefined = undefined;
  country: string | undefined = undefined;
  pointDTO: PointDtoModel | undefined = undefined;
  createdAt: string | undefined = undefined;
  owner: string | undefined = undefined;
  addressTypeValue: string | undefined = undefined;
  addressLabel: string | undefined = undefined;
  visibilityType: string | undefined = undefined;

}
